export var ReportType;
(function (ReportType) {
    ReportType["Unspecified"] = "unspecified";
    ReportType["ProgramReview"] = "programReview";
    ReportType["Spotlight"] = "spotlight";
    ReportType["WeeklySnapshot"] = "weeklySnapshot";
    ReportType["CumulativeSitePixelData"] = "cumulativeSitePixelData";
    ReportType["CumulativeIntentFeedTopics"] = "cumulativeIntentFeedTopics";
    ReportType["CumulativeIntentFeedBRS"] = "cumulativeIntentFeedBrs";
    ReportType["CumulativeAdSolutions"] = "cumulativeAdSolutions";
    ReportType["DisplayCumulativeAdSolutions"] = "displayCumulativeAdSolutions";
    ReportType["DisplayCumulativeIntentFeedBRS"] = "displayCumulativeIntentFeedBRS";
    ReportType["Moat"] = "moat";
    ReportType["DisplayAccountLevel"] = "displayAccountLevel";
    ReportType["InnovidAccountLevel"] = "innovidAccountLevel";
})(ReportType || (ReportType = {}));
export const ReportTypeLabel = {
    [ReportType.Unspecified]: 'Unspecified',
    [ReportType.Spotlight]: 'Account Spotlight',
    [ReportType.ProgramReview]: 'Program Review',
    [ReportType.WeeklySnapshot]: 'Weekly Snapshot',
    [ReportType.CumulativeAdSolutions]: 'Cumulative Ad Solutions',
    [ReportType.CumulativeIntentFeedBRS]: 'Cumulative Intent Feed BRS',
    [ReportType.CumulativeIntentFeedTopics]: 'Cumulative Intent Feed Topics',
    [ReportType.CumulativeSitePixelData]: 'Cumulative Site Pixel Data',
    [ReportType.DisplayCumulativeAdSolutions]: 'Display Cumulative Ad Solutions',
    [ReportType.DisplayCumulativeIntentFeedBRS]: 'Display Cumulative Intent Feed - BRS WoW',
    [ReportType.Moat]: 'MOAT',
    [ReportType.DisplayAccountLevel]: 'Account-Level Display Report',
    [ReportType.InnovidAccountLevel]: 'Innovid Account-Level Display Report',
};
/**
 * Which system renders a campaign PDF: the Python worker (default) or
 * job-runner. Only admins may pick job-runner while the new reports are tested.
 */
export var ReportGenerator;
(function (ReportGenerator) {
    ReportGenerator["Worker"] = "worker";
    ReportGenerator["JobRunner"] = "jobRunner";
})(ReportGenerator || (ReportGenerator = {}));
//# sourceMappingURL=ReportType.js.map